enum LicenceOrigin {
    MANUAL = 'manual',
    SUBSCRIPTION = 'subscription',
}

export default LicenceOrigin;
